import React from 'react';
import { CheckCircle2, XCircle, Zap } from 'lucide-react';
const comparisons = [{
  feature: 'Enfoque',
  other: 'Templates genéricos para cualquier negocio',
  us: 'Construido exclusivamente para contractors'
}, {
  feature: 'Estrategia',
  other: 'Solo enfocado en diseño',
  us: 'Diseño + estrategia de conversión'
}, {
  feature: 'Riesgo',
  other: 'Pagas todo por adelantado sin ver nada',
  us: 'Demo por $25 — pagas el resto solo si te gusta'
}, {
  feature: 'Tiempo',
  other: 'Semanas o meses para lanzar',
  us: 'Listo en menos de 72 horas'
}, {
  feature: 'Visibilidad',
  other: 'Sin estrategia de SEO',
  us: 'SEO local incluido desde el primer día'
}, {
  feature: 'Soporte',
  other: 'Sin soporte después del lanzamiento',
  us: 'Mantenimiento opcional disponible'
}, {
  feature: 'Resultados',
  other: 'Se ve bien pero no convierte',
  us: 'Construido para convertir visitas en llamadas'
}];
export function MechanismSection() {
  return <section className="py-24 bg-dark-100 relative overflow-hidden" data-id="element-218" data-mp="7qh7ywcs8zkb">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-219" data-mp="cpbqdx6u8m3w"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220" data-mp="3u3h6h3k0k5pj">
        <div className="text-center mb-16" data-id="element-221" data-mp="2y7dd30q3bbp">
          <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-6" data-id="element-222" data-mp="2ww6uvfw7pgw">
            <Zap className="w-4 h-4 text-gold mr-2" data-id="element-223" data-mp="3q4htcvo4p2n0" />
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-224" data-mp="3q1vleuxbsl49">
              La Solución
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-225" data-mp="3g593adwdw85x">
            Presentamos The Professional Presence System
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-226" data-mp="19g478x1lii6q">
            La solución digital completa creada exclusivamente para contractors
            locales que quieren verse tan profesionales como trabajan — por un
            solo pago accesible y sin complicaciones.
          </p>
        </div>

        <div className="bg-dark rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-227" data-mp="17wuiukl6auge">
          <div className="grid grid-cols-3 bg-dark-200 border-b border-white/10 p-6" data-id="element-228" data-mp="12zcgjd1nvdhd">
            <div className="col-span-1 font-bold text-gray-400 uppercase text-sm tracking-wider" data-id="element-229" data-mp="yz21lavw5cqd">
              Característica
            </div>
            <div className="col-span-1 font-bold text-gray-500 uppercase text-sm tracking-wider text-center" data-id="element-230" data-mp="1qox0nz9jwgs8">
              Otras Opciones
            </div>
            <div className="col-span-1 font-bold text-gold uppercase text-sm tracking-wider text-center" data-id="element-231" data-mp="1lwdkcujhb7jq">
              AS Elite Contractor
            </div>
          </div>

          <div className="divide-y divide-white/5" data-id="element-232" data-mp="2ef9gdwb1fhtd">
            {comparisons.map((item, index) => <div key={index} className="grid grid-cols-3 p-6 items-center hover:bg-white/[0.02] transition-colors" data-id="element-233" data-mp="29mga33zx81f6" data-mpi={index}>
                <div className="col-span-1 text-sm md:text-base font-medium text-gray-300 pr-4" data-id="element-234" data-mp="13oidt4om6mx">
                  {item.feature}
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-235" data-mp="5405dckioj1k">
                  <XCircle className="w-5 h-5 text-red-500/50 mb-2" data-id="element-236" data-mp="a5frl7yfkvlj" />
                  <span className="text-sm text-gray-500" data-id="element-237" data-mp="f4iuomuuorqv">{item.other}</span>
                </div>
                <div className="col-span-1 flex flex-col items-center text-center px-2" data-id="element-238" data-mp="k2ao5lb58lx6">
                  <CheckCircle2 className="w-6 h-6 text-gold mb-2" data-id="element-239" data-mp="ot0q0okd26n4" />
                  <span className="text-sm font-bold text-white" data-id="element-240" data-mp="ovwoce04exc3">
                    {item.us}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}